import { supabaseUrl as configuredSupabaseUrl } from '../../config/supabaseConfig';

/**
 * Client twin of supabase/functions/_shared/tenantLogoUrl.ts. A company logo
 * URL is tenant-controlled text that ends up in an <img src> / PDF <Image>, so
 * it is NEVER used as stored: it passes only if it is a raster object in THIS
 * tenant's own folder of the public `branding-assets` bucket, on the app's own
 * Supabase origin (an owner could otherwise store
 * https://evil.example/storage/v1/object/public/branding-assets/<tenant>/x.png
 * and turn every viewer's browser into a tracking-beacon request).
 *
 * `tenantId` is the session tenant (useAuth().tenantId) — never a prop from
 * elsewhere. Returns the original string, or null when it does not conform.
 */
const RASTER_EXT_RE = /\.(png|jpe?g|webp)$/i;
const UNSAFE_CHARS_RE = /[\s"'`<>\\]/;
const TENANT_ID_RE = /^[A-Za-z0-9_-]+$/;

export function resolveTenantLogoUrl(raw, tenantId, supabaseUrl = configuredSupabaseUrl) {
  if (typeof raw !== 'string' || !raw) return null;
  if (!supabaseUrl || typeof tenantId !== 'string' || !TENANT_ID_RE.test(tenantId)) return null;
  if (UNSAFE_CHARS_RE.test(raw)) return null;

  let base;
  try {
    base = new URL(supabaseUrl);
  } catch {
    return null;
  }
  if (base.protocol !== 'http:' && base.protocol !== 'https:') return null;

  const prefix = `${base.origin}/storage/v1/object/public/branding-assets/${tenantId}/`;
  if (!raw.startsWith(prefix)) return null;

  const path = raw.slice(prefix.length);
  if (!path || /[?#]/.test(path) || path.includes('..') || path.includes('%') || path.includes('/')) return null;
  if (!RASTER_EXT_RE.test(path)) return null;
  return raw;
}

export default resolveTenantLogoUrl;
